import { MenuItemBody } from '@/components/menu-item-body';
import { MenuItem } from '@/types';

export default function MenuDetailPage({
    response,
}: {
    response: { menuItem: MenuItem };
}) {
    return <MenuItemBody response={response} />;
}
